import styled from 'styled-components'

import { Col } from 'styles/components/layout'
import { H2 } from 'styles/components/typography'

export const Wrapper = styled.div`
  margin-right: -${p => p.theme.indents.baseIndentXs};
`

export const Answers = styled.div`
  border-radius: ${p => p.theme.blocks.blockBorderRadiusMedium};
  background: ${p =>
    p.colorTheme === 'dark'
      ? p.theme.colors.mineShaft
      : p.theme.colors.pictonBlue};
  position: relative;
  color: ${p => p.theme.colors.white};
  overflow: hidden;
`

export const H2Styled = styled(H2)`
  color: ${p => (p.colorTheme === 'dark' ? p.theme.colors.white : null)};
`

export const ColStyled = styled(Col)`
  position: relative;
  display: flex;
`
